export class BookingSlotDTO {
    dateTime: string

    constructor(dateTime: string) {
        this.dateTime = dateTime    
    }
}
